module.exports = __webpack_public_path__ + "img/login_gsnd.8d47f673.svg";